import {
  CHAT_LIST_QUERY_KEY,
  CHAT_QUERY_KEY,
} from "@frontend-shared/constants";
import type { IUpdateChatTitlePayload } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

export const useUpdateChatTitle = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: IUpdateChatTitlePayload) =>
      chatApi.updateChatTitle(params),
    onSuccess: (_data, { uuid }) => {
      queryClient.invalidateQueries({
        queryKey: [CHAT_LIST_QUERY_KEY],
      });
      // NOTE: NSAI-6473 — the open chat's header renders the title from the
      // chat's own query, so a rename (from the header or the sidebar) has to
      // refresh that too, or the header keeps the old name until a reload.
      queryClient.invalidateQueries({
        queryKey: [CHAT_QUERY_KEY, uuid],
      });
    },
  });
};
